export default ['Password must be at least 6 characters'];
